<template>
    <div class="home">
        <div class="homeConBox">
        </div>
    </div>
</template>

<script type="text/javascript">
    export default{
        props: ['curStoreId'],
    	data () {
    		return {
              
    		}
    	},
        methods: {
        },
        created: function () {
           
        },
        mounted: function () {
           
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
	@import "home";
</style>



// WEBPACK FOOTER //
// home.vue?3e0662c2